export enum UpdateQuoteActionButtonVariant {
  ADD_PRICE = "add-price",
  ADD_VEHICLE = "add-vehicle",
  VIEW_TRIP = "view-trip",
}
